enum UserRole {
	SuperAdministrator = "super_admin",
	Administrator = "administrator",
	Teacher = "teacher",
	Tutor = "tutor",
	Student = "student",
}

export default UserRole;
